import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import { channelActions } from '../../../_actions';
import { Input } from '../../../_components';

import Zenvia from '../../../_assets/zenvia-logo.png';

import moment from 'moment';

class ZenviaModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      zenviaLogin: '',
      zenviaPassword: '',
      zenviaSender: '',
      submitting: false,
      submitted: false
    }

    this.closeModal = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.activeChannels.forEach(element => {
      if (element.channel_type === 'ZENVIA') {
        this.setState({
          zenviaLogin: '',
          zenviaPassword: '',
          zenviaSender: element.properties.sender,
          uuid: element.uuid
        })
      }
    });
  }

  handleChange(e) {
    let name = e.target.name;
    let value = e.target.value;

    this.setState({[name]: value});
  }

  handleSubmit(e) {
    e.preventDefault();

    let self = this;

    const { zenviaLogin, zenviaPassword, zenviaSender, uuid } = this.state;
    const { dispatch, actionType } = this.props;
    
    this.setState({submitting: true, submitted: true});
    
    if ( !zenviaLogin && !zenviaPassword && !zenviaSender ) 
      return this.setState({submitting: false});

    let zenviaToken = btoa(`${zenviaLogin}:${zenviaPassword}`);
    let obj = {
      "channel": {
        "domain_uuid": JSON.parse(sessionStorage.getItem('selected_domain')).uuid,
        "channel_type": "ZENVIA",
        "properties": {
          "token": zenviaToken,
          "sender": zenviaSender
        }
      }
    }

    if (actionType === 'view')
      return false

    let action
    let constant
    
    if (actionType === 'edit') {
      obj.channel['uuid'] = uuid;

      action = channelActions.update(obj);
      constant = 'UPDATE_INTEGRATION_FAILURE';
    } else {
      action = channelActions.create(obj);
      constant = 'CHANNEL_INTEGRATION_FAILURE';
    }

    dispatch(action)
      .then(data => {
        if ( data.type !== constant ) {
          this.props.evt.handleSubmit();

          self.setState({submitting: false});
  
          return toast.success(data.data.message, {
            position: toast.POSITION.TOP_RIGHT,
            className: 'toast-success'
          });
        }
  
        self.setState({submitting: false})
  
        return toast.error(data.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          className: 'toast-error'
        });
      });
  }

  render() {
    const { submitted, submitting, zenviaLogin, zenviaPassword, zenviaSender } = this.state;
    const { actionType } = this.props;

    let title;
    let subtitle;
    let button;
    let buttonLoading;
    let readOnly;

    switch (actionType) {
      case 'edit':
        title = 'Editing Zenvia channel'
        subtitle = 'It is necessary that you provide your Zenvia login, password and sender name in the fields below.'
        button = 'Edit'
        buttonLoading = 'Editing...'
        break;
      case 'view':
        title = 'Zenvia Channel information for this Domain'
        subtitle = 'Here you can you find the configured information for this channel.'
        readOnly = true
        break;
      default:
        title = 'Adding Zenvia channel'
        subtitle = 'It is necessary that you provide your Zenvia login, password and sender name in the fields below.'
        button = 'Add'
        buttonLoading = 'Adding...'
        break;
    }

    return (
      <div className="modal fade" id={this.props.name+'Modal'} tabIndex="-1" role="dialog" aria-labelledby={this.props.name+'ModalLabel'} aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <img src={Zenvia} alt="Zenvia logo"/>
              <br/>
              <br/>
              <p className="title">{title}</p>
              <p className="disclaimer">{subtitle}</p>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" ref={this.closeModal}>
                <i className="lnr lnr-cross"></i>
              </button>
              <form action="#" className="form clearfix" id="zenviaChannelForm" method="POST" onSubmit={this.handleSubmit}>
                <div className="content-group">
                  {
                    !readOnly ?
                      <Input
                        label="Username"
                        type="text"
                        name="zenviaLogin"
                        submitted={submitted}
                        property={zenviaLogin}
                        hasChanged={this.handleChange}
                        onError="Provide your Zenvia username"
                      />
                    : ''
                  }
                  
                  {
                    !readOnly ?
                      <Input
                        label="Password"
                        type="password"
                        name="zenviaPassword"
                        submitted={submitted}
                        property={zenviaPassword}
                        hasChanged={this.handleChange}
                        onError="Provide your Zenvia password"
                      />
                    : ''
                  }

                  <Input
                    label="Sender name"
                    type="text"
                    name="zenviaSender"
                    submitted={submitted}
                    property={zenviaSender}
                    hasChanged={this.handleChange}
                    onError="Provide your Zenvia sender name"
                    readOnly={readOnly}
                  />
                </div>
                {
                  submitting ?
                    <button type="button" className="btn btn-blue float-right disabled" disabled>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      <span className="sr-only"> {buttonLoading}</span>
                    </button>    
                  : actionType === 'view' ?
                    <button type="submit" className="btn btn-blue float-right" data-dismiss="modal">OK</button> :
                    <button type="submit" className="btn btn-blue float-right">{button}</button>
                }
              </form>
              {
                actionType ?
                  <p className="edit">Last update: {moment(this.state.updated_at).format('MMMM Do YYYY, h:mm:ss a')}</p>
                : ''
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const { channelStatus } = state.createChannel;
  return channelStatus;
}

const ConnectedZenviaModal = connect(mapStateToProps)(ZenviaModal);
export { ConnectedZenviaModal as ZenviaModal }